module.exports = __webpack_public_path__ + "static/media/success-pickup-backdrop.b648be97.svg";